var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelFill = function SvgCancelFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m336-316 144-144 144 144 20-20-144-144 144-144-20-20-144 144-144-144-20 20 144 144-144 144zm144.17 184q-72.17 0-135.73-27.39t-110.57-74.35q-47.02-46.96-74.44-110.43Q132-407.65 132-479.83q0-72.17 27.39-135.73t74.35-110.57q46.96-47.02 110.43-74.44Q407.65-828 479.83-828q72.17 0 135.73 27.39t110.57 74.35q47.02 46.96 74.44 110.43Q828-552.35 828-480.17q0 72.17-27.39 135.73t-74.35 110.57q-46.96 47.02-110.43 74.44Q552.35-132 480.17-132"
  })));
};
export default SvgCancelFill;